import { Component, HostBinding, OnInit } from '@angular/core';
import { FeedbackService } from './feedback.service';
import { LoaderService } from 'app/loader/loader.service';
import { AlertService } from 'app/notification-alert/alert.service';
import { config } from 'app/app.config';
import { Table } from 'primeng/table';
import { Subject } from 'rxjs';

interface FeedbackData {
  question: string;
  answer: string;
  query_type: string;
  accurate: string;
  source_doc: string;
  comments: string;
  bot_reply: string;
}

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {
  @HostBinding('class.flex-grid') leftBarClass = true;
  @HostBinding('style.width') flexwidth = '100%';
  @HostBinding('style.flex-direction') direction = 'column';

  feedbackData: FeedbackData[] = [];
  sortedFeedbackData: FeedbackData[] = [];
  sortColumn: string = 'accurate';
  sortDirection: 'asc' | 'desc' = 'asc';

  search: string = "";

  RECORD_LIMIT = config.DEFAULT_RECORD_LIMIT;
  OFFSET = config.DEFAULT_OFFSET;
  totalRowCount: number = 0;
  isLoading: boolean = false;
  globalFilter: string = '';
  answerDialogVisible = false;
  showAnswerDialog = false;
  selectedAnswer: string = '';

  pageSize = 10;
  currentPage = 1;
  pagedData: any[] = [];

  searchInList = new Subject<any>();

  constructor(
    private feedbackService: FeedbackService,
    private httpLoader: LoaderService,
    private alert: AlertService
  ) {
    this.searchInList.debounceTime(500).subscribe(event => {
      this.search = event.target.value;

      if (!this.search) {
        return;
      }

      this.getFeedbackList(0);
    })
  }

  ngOnInit() {
    this.getFeedbackList(0);
    this.updatePagedData();
  }

  updatePagedData() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.pagedData = this.feedbackData.slice(start, end);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagedData();
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagedData();
    }
  }

  get totalPages() {
    return Math.ceil(this.feedbackData.length / this.pageSize);
  }

  /**
   * Fetch feedback list from API
   */
  getFeedbackList(pageNo) {

    try {
      if (pageNo === 0) {
        this.OFFSET = 0;
        this.httpLoader.showLoader();
      }

      const storedUserId = window.localStorage.getItem('user_id');
      const user_id = storedUserId ? JSON.parse(storedUserId) : null;

      const offset = this.OFFSET;
      const payLoad = {
        offset: offset,
        limit: this.RECORD_LIMIT,
        search: this.search || '',
        user_id: user_id
      };

      this.feedbackService.getFeedbackList(payLoad).subscribe(
        (response: any) => {
          console.log(response);

          this.httpLoader.hideLoader();
          this.isLoading = false;

          // Handle API response - adjust based on your API response structure
          if (response && response.result) {
            this.feedbackData = response.result;
            this.totalRowCount = response.count || response.total || 0;
          } else if (Array.isArray(response)) {
            // If API returns array directly
            this.feedbackData = response;
            this.totalRowCount = response.length;
          } else if (response && response.feedbackList) {
            this.feedbackData = response.feedbackList;
            this.totalRowCount = response.totalRowCount || 0;
          }

          // If no data from API, use sample data as fallback
          if (!this.feedbackData || this.feedbackData.length === 0) {
            this.loadSampleData();
          }

          this.sortedFeedbackData = [...this.feedbackData];
          this.sortData(this.sortColumn);
        },
        (error: any) => {
          this.httpLoader.hideLoader();
          this.isLoading = false;

          // Use sample data if API fails
          console.error('Error fetching feedback:', error);
          this.alert.error(error.error?.message || error.message || 'Error loading feedback data');
          this.loadSampleData();
        }
      );
    } catch (err) {
      this.httpLoader.hideLoader();
      this.isLoading = false;
      console.error('Exception in getFeedbackList:', err);
      this.loadSampleData();
    }
  }

  applyFilter() {
    // const table = document.querySelector('p-table') as Table;
    // table.filterGlobal(this.globalFilter, 'contains');
  }

  /**
   * Load sample data as fallback
   */
  loadSampleData() {
    // this.feedbackData = [
    //   {
    //     question: 'What is the claim number?',
    //     answer: '16105826',
    //     query_type: 'Claim Inquiry',
    //     accurate: 'yes',
    //     source_doc: '10/3/25, 7:20 AM',
    //     comments: 'overall accurate',
    //     bot_reply: 'The claim number is 16105826.'
    //   },
    //   {
    //     question: 'Can you provide the user details?',
    //     answer: 'test.user2@matrixcos.com',
    //     query_type: 'User Inquiry',
    //     accurate: 'no',
    //     source_doc: '9/24/25, 2:59 AM',
    //     comments: 'tet',
    //     bot_reply: 'The user details are available in the system.'
    //   },
    //   {
    //     question: 'What is the status of the claim?',
    //     answer: 'Jennifer Jimenez details',
    //     query_type: 'Status Inquiry',
    //     accurate: 'yes',
    //     source_doc: '9/24/25, 2:53 AM',
    //     comments: 'test',
    //     bot_reply: 'The claim status is under review.'
    //   },
    //   {
    //     question: 'When was the claim created?',
    //     answer: 'Brittany Terrazas',
    //     query_type: 'Date Inquiry',
    //     accurate: 'yes',
    //     source_doc: '9/23/25, 12:12 AM',
    //     comments: 'fdsfd',
    //     bot_reply: 'The claim was created on 9/23/25.'
    //   },
    //   {
    //     question: 'What documents are required?',
    //     answer: 'Test User details',
    //     query_type: 'Document Inquiry',
    //     accurate: 'yes',
    //     source_doc: '9/2/25, 10:29 PM',
    //     comments: 'The accuracy is somewhat correct.',
    //     bot_reply: 'Please provide the required documents for processing.'
    //   },
    //   {
    //     question: 'What is the employee information?',
    //     answer: 'Jennifer Jimenez',
    //     query_type: 'Employee Inquiry',
    //     accurate: 'no',
    //     source_doc: '8/31/25, 4:38 PM',
    //     comments: 'The employee is Jennifer Stephens and yet it states that Liane Lowrey was granted leave. Liane is the HR Rep. Also the dates are confusing and I\'m assuming what was an example provided by the client was also included in the summary but I do not see it anywhere in the notes. Very misleading and inaccurate summary.',
    //     bot_reply: 'The employee information may contain some inaccuracies.'
    //   },
    //   {
    //     question: 'Is the summary accurate?',
    //     answer: 'Brittany Terrazas',
    //     query_type: 'Accuracy Inquiry',
    //     accurate: 'yes',
    //     source_doc: '8/31/25, 4:34 PM',
    //     comments: 'Very accurate summary. I have not suggestions.',
    //     bot_reply: 'The summary has been verified as accurate.'
    //   }
    // ];
    this.sortedFeedbackData = [...this.feedbackData];
    this.sortData(this.sortColumn);
  }

  sortData(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    // Sort local data
    this.sortLocalData(column);
  }

  /**
   * Sort data locally
   */
  sortLocalData(column: string) {
    this.sortedFeedbackData = [...this.feedbackData].sort((a, b) => {
      let aValue: any = a[column as keyof FeedbackData];
      let bValue: any = b[column as keyof FeedbackData];

      // Handle date sorting
      if (column === 'source_doc') {
        // Parse date format like "10/3/25, 7:20 AM"
        aValue = this.parseDate(aValue);
        bValue = this.parseDate(bValue);
      }

      // Handle string comparison
      if (typeof aValue === 'string' && typeof bValue === 'string') {
        aValue = aValue.toLowerCase();
        bValue = bValue.toLowerCase();
      }

      if (aValue < bValue) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (aValue > bValue) {
        return this.sortDirection === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  getSourceDocDisplay(sourceDoc: any): string {
    // Customize display format if needed
    return sourceDoc.join(', ');
  }
  /**
   * Refresh feedback list
   */
  refreshFeedbackList() {
    this.getFeedbackList(0);
  }

  getShortAnswer(answer: string): string {
    const plainText = answer?.replace(/<[^>]+>/g, ' '); // strip HTML tags

    if (plainText && plainText.length > 30) {
      return plainText.substring(0, 100) + '...';
    }
    return plainText;
  }

  // Open dialog with full answer
  openAnswerDialog(answer: string) {
    this.selectedAnswer = answer;
    this.showAnswerDialog = true;
  }

  /**
   * Load more data (pagination)
   */
  loadMore() {
    if (this.feedbackData.length < this.totalRowCount && !this.isLoading) {
      this.OFFSET += this.RECORD_LIMIT;
      try {
        this.isLoading = true;
        const user_id = window.localStorage.getItem('user_id') ? JSON.parse(window.localStorage.getItem('user_id')) : null;
        const payLoad = {
          offset: this.OFFSET,
          limit: this.RECORD_LIMIT,
          sort: this.sortColumn,
          order: this.sortDirection,
          user_id: user_id
        };

        this.feedbackService.getFeedbackList(payLoad).subscribe(
          (response: any) => {
            this.isLoading = false;

            // Handle API response - append new data
            let newData: FeedbackData[] = [];
            if (response && response.data) {
              newData = response.data;
            } else if (Array.isArray(response)) {
              newData = response;
            } else if (response && response.feedbackList) {
              newData = response.feedbackList;
            }

            // Append new data to existing data
            if (newData && newData.length > 0) {
              this.feedbackData = [...this.feedbackData, ...newData];
              this.sortedFeedbackData = [...this.feedbackData];
              this.sortLocalData(this.sortColumn);
            }
          },
          (error: any) => {
            this.isLoading = false;
            console.error('Error loading more feedback:', error);
            this.alert.error(error.error?.message || error.message || 'Error loading more feedback');
          }
        );
      } catch (err) {
        this.isLoading = false;
        console.error('Exception in loadMore:', err);
      }
    }
  }

  parseDate(dateString: string): number {
    try {
      // Handle format like "10/3/25, 7:20 AM"
      const parts = dateString.split(', ');
      const datePart = parts[0];
      const timePart = parts[1];

      if (datePart && timePart) {
        const [month, day, year] = datePart.split('/');
        const [time, ampm] = timePart.split(' ');
        const [hours, minutes] = time.split(':');

        let hour24 = parseInt(hours, 10);
        if (ampm === 'PM' && hour24 !== 12) {
          hour24 += 12;
        } else if (ampm === 'AM' && hour24 === 12) {
          hour24 = 0;
        }

        const fullYear = parseInt('20' + year, 10);
        const date = new Date(fullYear, parseInt(month, 10) - 1, parseInt(day, 10), hour24, parseInt(minutes, 10));
        return date.getTime();
      }

      return new Date(dateString).getTime();
    } catch (e) {
      return new Date(dateString).getTime();
    }
  }

  getSortIcon(column: string): string {
    if (this.sortColumn !== column) {
      return 'fa-sort';
    }
    return this.sortDirection === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc';
  }

  formatDateTime(dateString: string): string {
    if (!dateString) return '';

    try {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      let hours24 = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      const ampm = hours24 >= 12 ? 'PM' : 'AM';
      let hours12 = hours24 % 12;
      if (hours12 === 0) {
        hours12 = 12;
      }
      const hours = String(hours12).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${ampm}`;
    } catch (e) {
      return dateString;
    }
  }
}